// TabPanel.jsx
import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& .MuiTabs-indicator": {
        backgroundColor: theme.palette.secondary[500],
    },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: "none",
    minWidth: 100,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
        color: theme.palette.primary.main,
    },
}));

export const TabPanel = ({ children, value, index }) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`platform-tabpanel-${index}`}
            aria-labelledby={`platform-tab-${index}`}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
};

export const PlatformTabs = ({ tabs, value, onChange }) => {
    const displayTabs = tabs.slice(0, 6);
    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <StyledTabs value={value} onChange={onChange}>
                    {displayTabs.map((tab, index) => (
                        <StyledTab key={index} label={tab} />
                    ))}
                </StyledTabs>
            </Box>
        </Box>
    );
};
